import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './loading.scss';

const Loading = () => {

  return (
    <div styleName="load-bar">
      <div styleName="bar"/>
      <div styleName="bar"/>
      <div styleName="bar"/>
    </div>
  );
};

export default CSSModules(styles, {allowMultiple: true} )(Loading);



// WEBPACK FOOTER //
// ./src/components/loading/Loading.js